import * as Sentry from '@sentry/angular';
import type { WebRuntimeConfig } from './runtime-config';

export function initSentry(config: Readonly<WebRuntimeConfig>): void {
  const replayEnabled =
    config.sentryReplaysSessionSampleRate > 0 ||
    config.sentryReplaysOnErrorSampleRate > 0;

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment,
    release: config.sentryRelease,
    enabled: Boolean(config.sentryDsn),
    tracesSampleRate: config.sentryTracesSampleRate,
    tracePropagationTargets: ['localhost', config.apiUrl].filter(Boolean),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
      ...(replayEnabled
        ? [Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })]
        : []),
    ],
    replaysSessionSampleRate: config.sentryReplaysSessionSampleRate,
    replaysOnErrorSampleRate: config.sentryReplaysOnErrorSampleRate,
    enableLogs: true,
  });
}
